import { onResponse, onResponseError } from '@/business/core/clients/http/instances/real/response.interceptor';
import { onRequest, onRequestError } from '@/business/core/clients/http/instances/real/request.interceptor';
import HttpClient from '@/business/core/clients/http/helpers/generator.helper';
import getEnv from '@/business/core/utils/getEnv.util';

const HEADERS = {
	'Content-Type': 'application/json',
	'Cache-Control': 'no-cache',
};
const TIMEOUT = 2 * 60 * 1000;
// const isProductionMode = import.meta.env.MODE === 'production';
// isProductionMode ? getEnv('API_BASE_URL') : '/api',

export default new HttpClient({
	timeout: TIMEOUT,
	baseURL: getEnv('API_BASE_URL'),
	interceptors: [{ onResponse, onResponseError, onRequest, onRequestError }],
	headers: HEADERS,
}).getInstance();
